import React from 'react';
import './App.css';
import Header from './components/header/Header';
import About from './components/about/About';
import Home from './components/home/Home';
import Services from './components/services/Services';
import { BrowserRouter, Route, Routes } from 'react-router';


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        
        <div className="Container">
        {/* Define Routes for each component */}
        <Routes>
          <Route path="/" element={ <Home />} />
          <Route path="/about" element={ <About />} />
          <Route path="/services" element={<Services/>} /> 
        </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;